export const DEVTOOLS_MESSAGE_IDENTIFIER = '__ems-devtools__' as const;
export const DEVTOOLS_HOOKS_IDENTIFIER = '__PULSE_DEVTOOLS_HOOKS__' as const;
export const DEVTOOLS_LOCAL_STORAGE_KEY = 'enableEMSDevtools' as const;
export const DEVTOOLS_PRINT_LOGS_TO_CONSOLE = 'printEMSLogsToConsole' as const;
